import {Form, Formik} from 'formik';
import Header from 'modules/header/farm/main';
import Description from './description';
import {initialValues} from './utilities/initialValues';
import {schema} from './utilities/validationSchema';
import {useFarm} from 'context/farmContext';
import {formDataCreator} from '../../utilities/formDataCreatot';
import usePostAd from '../../hooks/usePostAd';
import AuctionFormComponent from 'components/forms/auction';
import useSetAnswers from '../simple/hooks/useSetAnswers';
import {useState} from 'react';
import { googleAnalyticsInstance } from 'utilities/helper/googleAnalitics';
import { FarmEvents } from 'utilities/helper/googleAnalitics/EventHelper';

const AuctionForm = () => {
  const {farm} = useFarm();
  const {isLoading, mutate} = usePostAd();
  const {answers, handleAnswers} = useSetAnswers();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  return (
    <>
      <Header title=" ثبت آگهی مزایده" />
      <Description />
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={values => {
          const payload = new FormData();
          formDataCreator(payload, farm);
          payload.append('price', values.price);
          payload.append('duration', values.duration);
          payload.append('duration_unit', values.duration_unit);
          if (answers.length > 0 && isChecked) {
            const answersGuid: string[] = [];
            answers.map(item => answersGuid.push(item.guid));
            payload.append('answers', answersGuid.toString());
          }
          !isLoading && mutate(payload);
          googleAnalyticsInstance.eventGoogleAnalytics(
            FarmEvents.addedSimple,
          );
        }}
      >
        {({values}) => (
          <Form className="px-3 pb-4">
            <AuctionFormComponent
              values={values}
              isLoading={isLoading}
              subProduct={farm?.subProduct}
              handleAnswers={handleAnswers}
              answers={answers}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AuctionForm;
